import merge from 'lodash/merge';
import { RECEIVE_PRICE_ERROR, RECEIVE_PRICES, PRICE_VIEW } from './product-actions';

export const parsePrices = (prices) => {
	return Object.keys(prices).reduce((acc, key) => {
		acc[key] = { ...prices[key], priceFetchFailed: false };
		return acc;
	}, {});
}

const PriceReducer = (state = {}, action) => {
	Object.freeze(state);
	switch(action.type) {
		case RECEIVE_PRICES:
			return merge({}, state, parsePrices(action.prices));
		case RECEIVE_PRICE_ERROR:
			// create sku to catentryid map
			const skuIdMap = action.failedCatentryIds.reduce((acc, id) => {
				const product = action.products.find(product => product.itemId === id);
				if (product) {
					acc[id] = product.sku;
				}
				return acc;
			}, {});

			// generate state update object
			const update = action.failedCatentryIds.reduce((acc, id) => {
				const sku = skuIdMap[id];
				acc[sku] = { priceFetchFailed: true };
				return acc;
			}, {});

			return merge({}, state, update);
		case PRICE_VIEW: 
			const prefetchPrice = state.prefetchPrice || [];
			prefetchPrice.push(action.priceId)
			return merge({}, state, { prefetchPrice });
		default:
			return state;
	}
};

export default PriceReducer;
